import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTE_TO_PRODUCT_MAP } from './sportsbook-constants.js';

/*
 * A lazy way to get the product from a full path
 * Note that this function expects language code as well!
 * It takes the full path in order to ignore context in the application
 */
const getProductFromFullPath = path => {
	if (!path) {
		return undefined;
	}

	const product = path.split('/')[2];
	const productRoute = '/'.concat(product);

	return ROUTE_TO_PRODUCT_MAP[productRoute];
};

/**
 * Returns the current active sportsbook product no matter the sub url
 * @returns string of the current active sportsbook product or falsy if not on sportsbook
 */
const useSportsbookProduct = () => {
	const location = useLocation();
	const product = useMemo(
		() => getProductFromFullPath(window?.location?.pathname),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[location.pathname]
	);
	return product;
};

export default useSportsbookProduct;
